import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  list: "gatewaySummary/listOutBound",
  pdfDownload: "gatewaySummary/generateAndDownloadOutBoundPdf",
  csvDownload: "gatewaySummary/downloadOutBoundCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Outbound Gateway",
      accessor: "coralGateway",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
      //filterControlType: "select",
      options: {
        keyField: "gateway",
        keyDescription: "gateway",
        values: [],
        url: "extensionBilling/listInBound",
      },
    },
    {
      Header: "Date",
      accessor: "callDate",
      displayInList: false,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      dateTime: false,
      downloadReports: false,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Intercom Call",
      accessor: "intercomCall",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      dateTime: false,
      sortDisable: true,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Intercom Cost",
      accessor: "intercomCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value, row }) => <RupeeCell value={value} row={row} />,
    },

    {
      Header: "Local Call",
      accessor: "localCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Local Cost",
      accessor: "localCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },

    {
      Header: "STD Call",
      accessor: "stdCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "STD Cost",
      accessor: "stdCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
    {
      Header: "ISD Call",
      accessor: "isdCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ISD Cost",
      accessor: "isdCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },

    {
      Header: "Total Call",
      accessor: "totalCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Cost",
      accessor: "totalCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <RupeeCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
